export default "dist/images/block-team-member-basic.6fdd963.png";